export const wheelData = [
  {
    name: "Spitfire Formula 4 99a Wheels",
    price: "45",
    src: "wheel-01.glb",
    thumbSrc: "wheel-01.png",
  },
  {
    name: "Mini Log 101A C-Cut 52mm",
    price: "45",
    src: "wheel-02.glb",
    thumbSrc: "wheel-02.png",
  },
  {
    name: "Spitfire 51mm Wheels",
    price: "49",
    src: "wheel-03.glb",
    thumbSrc: "wheel-03.png",
  },
  {
    name: "Special Donut by The Mob",
    price: "49",
    src: "wheel-04.glb",
    thumbSrc: "wheel-04.png",
  },
  {
    name: "Bones Wheels",
    price: "39",
    src: "wheel-06.glb",
    thumbSrc: "wheel-06.png",
  },
]
